import util from './util';

export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.$router.push({ path: 'dashboard' });
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      // Logout 호출
      util.logOut(this);
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setLocale', null);
      this.$cookies.remove('token');
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Logout successfully.'
      };
      this.$router.replace({ path: '/' });
    }
  },
  {
    name: 'APP_GO_PROFILE',
    callback: function (e) {
      this.$router.replace({ path: '/profile' });
    }
  },
  {
    name: 'APP_USER_REGISTER',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'User registered. Please wait until your administrator approves.'
      };
      this.$router.replace({ path: '/login' });
    }
  },
  {
    name: 'APP_USER_LOGIN_REQUESTED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'pink',
        text: 'Please wait until your administrator approves.'
      };
      this.$router.replace({ path: '/login' });
    }
  },
  {
    name: 'APP_SNACK_BAR',
    callback: function (text, color) {
      this.snackbar = {
        show: true,
        color: color,
        text: text
      };
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.$router.push('/login');
      this.$message.error('Token has expired');
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    }
  },

];



// WEBPACK FOOTER //
// ./src/event.js